/**
 * College basketball team registry. Keyed by school name; each logo URL carries the ESPN team id.
 * The women's league is the same schools minus those with no women's Division I team.
 */

import type { TeamInfo } from './teams';

export const NCAAB_TEAMS: Record<string, TeamInfo> = {
  'Abilene Christian': { abbr: 'ACU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2000.png' },
  'Air Force': { abbr: 'AF', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2005.png' },
  Akron: { abbr: 'AKR', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2006.png' },
  'Alabama A&M': { abbr: 'AAMU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2010.png' },
  Alabama: { abbr: 'ALA', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/333.png' },
  'Alabama State': { abbr: 'ALST', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2011.png' },
  'Alcorn State': { abbr: 'ALCN', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2016.png' },
  'American University': {
    abbr: 'AMER',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/44.png',
  },
  'App State': { abbr: 'APP', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2026.png' },
  'Arizona State': { abbr: 'ASU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/9.png' },
  Arizona: { abbr: 'ARIZ', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/12.png' },
  Arkansas: { abbr: 'ARK', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/8.png' },
  'Arkansas State': { abbr: 'ARST', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2032.png' },
  'Arkansas-Pine Bluff': {
    abbr: 'UAPB',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2029.png',
  },
  Army: { abbr: 'ARMY', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/349.png' },
  Auburn: { abbr: 'AUB', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2.png' },
  'Austin Peay': { abbr: 'APSU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2046.png' },
  'Ball State': { abbr: 'BALL', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2050.png' },
  Baylor: { abbr: 'BAY', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/239.png' },
  Bellarmine: { abbr: 'BELL', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/91.png' },
  Belmont: { abbr: 'BEL', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2057.png' },
  'Bethune-Cookman': { abbr: 'BCU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2065.png' },
  Binghamton: { abbr: 'BING', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2066.png' },
  'Boise State': { abbr: 'BOIS', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/68.png' },
  'Boston College': { abbr: 'BC', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/103.png' },
  'Boston University': { abbr: 'BU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/104.png' },
  'Bowling Green': { abbr: 'BGSU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/189.png' },
  Bradley: { abbr: 'BRAD', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/71.png' },
  Brown: { abbr: 'BRWN', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/225.png' },
  Bryant: { abbr: 'BRY', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2803.png' },
  Bucknell: { abbr: 'BUCK', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2083.png' },
  Buffalo: { abbr: 'BUF', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2084.png' },
  Butler: { abbr: 'BUT', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2086.png' },
  BYU: { abbr: 'BYU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/252.png' },
  'Cal Poly': { abbr: 'CP', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/13.png' },
  'Cal State Bakersfield': {
    abbr: 'CSUB',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2934.png',
  },
  'Cal State Fullerton': {
    abbr: 'CSUF',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2239.png',
  },
  'Cal State Northridge': {
    abbr: 'CSUN',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2463.png',
  },
  'California Baptist': {
    abbr: 'CBU',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2856.png',
  },
  California: { abbr: 'CAL', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/25.png' },
  Campbell: { abbr: 'CAM', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2097.png' },
  Canisius: { abbr: 'CAN', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2099.png' },
  'Central Arkansas': { abbr: 'CARK', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2110.png' },
  'Central Connecticut': {
    abbr: 'CCSU',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2115.png',
  },
  'Central Michigan': { abbr: 'CMU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2117.png' },
  Charleston: { abbr: 'COFC', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/232.png' },
  'Charleston Southern': {
    abbr: 'CHSO',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2127.png',
  },
  Charlotte: { abbr: 'CLT', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2429.png' },
  Chattanooga: { abbr: 'UTC', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/236.png' },
  'Chicago State': { abbr: 'CHST', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2130.png' },
  Cincinnati: { abbr: 'CIN', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2132.png' },
  Clemson: { abbr: 'CLEM', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/228.png' },
  'Cleveland State': { abbr: 'CLE', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/325.png' },
  'Coastal Carolina': { abbr: 'CCU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/324.png' },
  Colgate: { abbr: 'COLG', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2142.png' },
  Colorado: { abbr: 'COLO', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/38.png' },
  'Colorado State': { abbr: 'CSU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/36.png' },
  Columbia: { abbr: 'COLU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/171.png' },
  'Coppin State': { abbr: 'COPP', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2154.png' },
  Cornell: { abbr: 'COR', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/172.png' },
  Creighton: { abbr: 'CREI', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/156.png' },
  Dartmouth: { abbr: 'DART', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/159.png' },
  Davidson: { abbr: 'DAV', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2166.png' },
  Dayton: { abbr: 'DAY', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2168.png' },
  Delaware: { abbr: 'DEL', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/48.png' },
  'Delaware State': { abbr: 'DSU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2169.png' },
  Denver: { abbr: 'DEN', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2172.png' },
  DePaul: { abbr: 'DEP', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/305.png' },
  'Detroit Mercy': { abbr: 'DETM', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2174.png' },
  Drake: { abbr: 'DRKE', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2181.png' },
  Drexel: { abbr: 'DREX', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2182.png' },
  Duke: { abbr: 'DUKE', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/150.png' },
  Duquesne: { abbr: 'DUQ', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2184.png' },
  'East Carolina': { abbr: 'ECU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/151.png' },
  'East Tennessee State': {
    abbr: 'ETSU',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2193.png',
  },
  'East Texas A&M': { abbr: 'ETAM', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2837.png' },
  'Eastern Illinois': { abbr: 'EIU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2197.png' },
  'Eastern Kentucky': { abbr: 'EKU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2198.png' },
  'Eastern Michigan': { abbr: 'EMU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2199.png' },
  'Eastern Washington': { abbr: 'EWU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/331.png' },
  Elon: { abbr: 'ELON', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2210.png' },
  Evansville: { abbr: 'EVAN', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/339.png' },
  Fairfield: { abbr: 'FAIR', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2217.png' },
  'Fairleigh Dickinson': {
    abbr: 'FDU',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/161.png',
  },
  'Florida A&M': { abbr: 'FAMU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/50.png' },
  'Florida Atlantic': { abbr: 'FAU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2226.png' },
  Florida: { abbr: 'FLA', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/57.png' },
  'Florida Gulf Coast': {
    abbr: 'FGCU',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/526.png',
  },
  'Florida International': {
    abbr: 'FIU',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2229.png',
  },
  'Florida State': { abbr: 'FSU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/52.png' },
  Fordham: { abbr: 'FOR', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2230.png' },
  'Fresno State': { abbr: 'FRES', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/278.png' },
  Furman: { abbr: 'FUR', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/231.png' },
  'Gardner-Webb': { abbr: 'GWEB', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2241.png' },
  'George Mason': { abbr: 'GMU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2244.png' },
  'George Washington': { abbr: 'GW', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/45.png' },
  Georgetown: { abbr: 'GTWN', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/46.png' },
  Georgia: { abbr: 'UGA', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/61.png' },
  'Georgia Southern': { abbr: 'GASO', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/290.png' },
  'Georgia State': { abbr: 'GAST', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2247.png' },
  'Georgia Tech': { abbr: 'GT', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/59.png' },
  Gonzaga: { abbr: 'GONZ', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2250.png' },
  Grambling: { abbr: 'GRAM', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2755.png' },
  'Grand Canyon': { abbr: 'GCU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2253.png' },
  'Green Bay': { abbr: 'GB', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2739.png' },
  Hampton: { abbr: 'HAMP', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2261.png' },
  Harvard: { abbr: 'HARV', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/108.png' },
  "Hawai'i": { abbr: 'HAW', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/62.png' },
  'High Point': { abbr: 'HPU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2272.png' },
  Hofstra: { abbr: 'HOF', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2275.png' },
  'Holy Cross': { abbr: 'HC', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/107.png' },
  'Houston Christian': { abbr: 'HCU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2277.png' },
  Houston: { abbr: 'HOU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/248.png' },
  Howard: { abbr: 'HOW', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/47.png' },
  'Idaho State': { abbr: 'IDST', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/304.png' },
  Idaho: { abbr: 'IDHO', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/70.png' },
  Illinois: { abbr: 'ILL', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/356.png' },
  'Illinois State': { abbr: 'ILST', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2287.png' },
  'Incarnate Word': { abbr: 'UIW', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2916.png' },
  Indiana: { abbr: 'IU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/84.png' },
  'Indiana State': { abbr: 'INST', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/282.png' },
  Iona: { abbr: 'IONA', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/314.png' },
  Iowa: { abbr: 'IOWA', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2294.png' },
  'Iowa State': { abbr: 'ISU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/66.png' },
  'IU Indianapolis': { abbr: 'IUIN', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/85.png' },
  'Jackson State': { abbr: 'JKST', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2296.png' },
  Jacksonville: { abbr: 'JAX', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/294.png' },
  'Jacksonville State': { abbr: 'JXST', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/55.png' },
  'James Madison': { abbr: 'JMU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/256.png' },
  'Kansas City': { abbr: 'KC', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/140.png' },
  Kansas: { abbr: 'KU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2305.png' },
  'Kansas State': { abbr: 'KSU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2306.png' },
  'Kennesaw State': { abbr: 'KENN', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/338.png' },
  'Kent State': { abbr: 'KENT', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2309.png' },
  Kentucky: { abbr: 'UK', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/96.png' },
  'La Salle': { abbr: 'LAS', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2325.png' },
  Lafayette: { abbr: 'LAF', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/322.png' },
  Lamar: { abbr: 'LAM', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2320.png' },
  'Le Moyne': { abbr: 'LEM', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2330.png' },
  Lehigh: { abbr: 'LEH', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2329.png' },
  Liberty: { abbr: 'LIB', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2335.png' },
  Lindenwood: { abbr: 'LIN', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2815.png' },
  Lipscomb: { abbr: 'LIP', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/288.png' },
  'Little Rock': { abbr: 'LR', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2031.png' },
  'Long Beach State': { abbr: 'LBSU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/299.png' },
  'Long Island University': {
    abbr: 'LIU',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/112358.png',
  },
  Longwood: { abbr: 'LONG', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2344.png' },
  Louisiana: { abbr: 'UL', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/309.png' },
  'Louisiana Tech': { abbr: 'LT', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2348.png' },
  Louisville: { abbr: 'LOU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/97.png' },
  'Loyola Chicago': { abbr: 'LUC', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2350.png' },
  'Loyola Maryland': { abbr: 'L-MD', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2352.png' },
  'Loyola Marymount': { abbr: 'LMU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2351.png' },
  LSU: { abbr: 'LSU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/99.png' },
  Maine: { abbr: 'ME', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/311.png' },
  Manhattan: { abbr: 'MAN', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2363.png' },
  Marist: { abbr: 'MRST', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2368.png' },
  Marquette: { abbr: 'MARQ', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/269.png' },
  Marshall: { abbr: 'MRSH', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/276.png' },
  'Maryland Eastern Shore': {
    abbr: 'UMES',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2379.png',
  },
  Maryland: { abbr: 'MD', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/120.png' },
  Massachusetts: { abbr: 'MASS', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/113.png' },
  McNeese: { abbr: 'MCN', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2377.png' },
  Memphis: { abbr: 'MEM', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/235.png' },
  Mercer: { abbr: 'MER', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2382.png' },
  Mercyhurst: { abbr: 'MERC', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2385.png' },
  Merrimack: { abbr: 'MRMK', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2771.png' },
  'Miami (OH)': { abbr: 'M-OH', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/193.png' },
  Miami: { abbr: 'MIA', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2390.png' },
  'Michigan State': { abbr: 'MSU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/127.png' },
  Michigan: { abbr: 'MICH', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/130.png' },
  'Middle Tennessee': { abbr: 'MTSU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2393.png' },
  Milwaukee: { abbr: 'MILW', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/270.png' },
  Minnesota: { abbr: 'MINN', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/135.png' },
  'Mississippi State': { abbr: 'MSST', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/344.png' },
  'Mississippi Valley State': {
    abbr: 'MVSU',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2400.png',
  },
  'Missouri State': { abbr: 'MOST', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2623.png' },
  Missouri: { abbr: 'MIZ', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/142.png' },
  Monmouth: { abbr: 'MONM', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2405.png' },
  Montana: { abbr: 'MONT', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/149.png' },
  'Montana State': { abbr: 'MTST', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/147.png' },
  'Morehead State': { abbr: 'MORE', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2413.png' },
  'Morgan State': { abbr: 'MORG', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2415.png' },
  "Mount St. Mary's": { abbr: 'MSM', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/116.png' },
  'Murray State': { abbr: 'MUR', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/93.png' },
  Navy: { abbr: 'NAVY', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2426.png' },
  'NC State': { abbr: 'NCSU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/152.png' },
  Nebraska: { abbr: 'NEB', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/158.png' },
  Nevada: { abbr: 'NEV', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2440.png' },
  'New Hampshire': { abbr: 'UNH', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/160.png' },
  'New Haven': { abbr: 'NHVN', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2441.png' },
  'New Mexico': { abbr: 'UNM', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/167.png' },
  'New Mexico State': { abbr: 'NMSU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/166.png' },
  'New Orleans': { abbr: 'UNO', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2443.png' },
  Niagara: { abbr: 'NIA', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/315.png' },
  Nicholls: { abbr: 'NICH', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2447.png' },
  NJIT: { abbr: 'NJIT', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2885.png' },
  'Norfolk State': { abbr: 'NORF', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2450.png' },
  'North Alabama': { abbr: 'UNA', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2453.png' },
  'North Carolina A&T': {
    abbr: 'NCAT',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2448.png',
  },
  'North Carolina Central': {
    abbr: 'NCCU',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2428.png',
  },
  'North Carolina': { abbr: 'UNC', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/153.png' },
  'North Dakota': { abbr: 'UND', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/155.png' },
  'North Dakota State': {
    abbr: 'NDSU',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2449.png',
  },
  'North Florida': { abbr: 'UNF', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2454.png' },
  'North Texas': { abbr: 'UNT', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/249.png' },
  Northeastern: { abbr: 'NE', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/111.png' },
  'Northern Arizona': { abbr: 'NAU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2464.png' },
  'Northern Colorado': {
    abbr: 'UNCO',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2458.png',
  },
  'Northern Illinois': { abbr: 'NIU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2459.png' },
  'Northern Iowa': { abbr: 'UNI', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2460.png' },
  'Northern Kentucky': { abbr: 'NKU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/94.png' },
  'Northwestern State': {
    abbr: 'NWST',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2466.png',
  },
  Northwestern: { abbr: 'NU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/77.png' },
  'Notre Dame': { abbr: 'ND', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/87.png' },
  Oakland: { abbr: 'OAK', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2473.png' },
  Ohio: { abbr: 'OHIO', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/195.png' },
  'Ohio State': { abbr: 'OSU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/194.png' },
  Oklahoma: { abbr: 'OU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/201.png' },
  'Oklahoma State': { abbr: 'OKST', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/197.png' },
  'Old Dominion': { abbr: 'ODU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/295.png' },
  'Ole Miss': { abbr: 'MISS', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/145.png' },
  Omaha: { abbr: 'OMA', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2437.png' },
  'Oral Roberts': { abbr: 'ORU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/198.png' },
  Oregon: { abbr: 'ORE', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2483.png' },
  'Oregon State': { abbr: 'ORST', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/204.png' },
  Pacific: { abbr: 'PAC', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/279.png' },
  'Penn State': { abbr: 'PSU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/213.png' },
  Pennsylvania: { abbr: 'PENN', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/219.png' },
  Pepperdine: { abbr: 'PEPP', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2492.png' },
  Pittsburgh: { abbr: 'PITT', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/221.png' },
  Portland: { abbr: 'PORT', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2501.png' },
  'Portland State': { abbr: 'PRST', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2502.png' },
  'Prairie View A&M': { abbr: 'PV', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2504.png' },
  Presbyterian: { abbr: 'PRES', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2506.png' },
  Princeton: { abbr: 'PRIN', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/163.png' },
  Providence: { abbr: 'PROV', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2507.png' },
  Purdue: { abbr: 'PUR', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2509.png' },
  'Purdue Fort Wayne': { abbr: 'PFW', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2870.png' },
  Queens: { abbr: 'QUC', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2511.png' },
  Quinnipiac: { abbr: 'QUIN', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2514.png' },
  Radford: { abbr: 'RAD', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2515.png' },
  'Rhode Island': { abbr: 'URI', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/227.png' },
  Rice: { abbr: 'RICE', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/242.png' },
  Richmond: { abbr: 'RICH', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/257.png' },
  Rider: { abbr: 'RID', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2520.png' },
  'Robert Morris': { abbr: 'RMU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2523.png' },
  Rutgers: { abbr: 'RUTG', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/164.png' },
  'Sacramento State': { abbr: 'SAC', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/16.png' },
  'Sacred Heart': { abbr: 'SHU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2529.png' },
  'Saint Francis': { abbr: 'SFPA', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2598.png' },
  "Saint Joseph's": { abbr: 'JOES', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2603.png' },
  'Saint Louis': { abbr: 'SLU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/139.png' },
  "Saint Mary's": { abbr: 'SMC', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2608.png' },
  "Saint Peter's": { abbr: 'SPU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2612.png' },
  'Sam Houston': { abbr: 'SHSU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2534.png' },
  Samford: { abbr: 'SAM', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2535.png' },
  'San Diego State': { abbr: 'SDSU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/21.png' },
  'San Diego': { abbr: 'USD', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/301.png' },
  'San Francisco': { abbr: 'SF', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2539.png' },
  'San José State': { abbr: 'SJSU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/23.png' },
  'Santa Clara': { abbr: 'SCU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2541.png' },
  'SE Louisiana': { abbr: 'SELA', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2545.png' },
  'Seattle U': { abbr: 'SEA', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2547.png' },
  'Seton Hall': { abbr: 'HALL', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2550.png' },
  Siena: { abbr: 'SIE', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2561.png' },
  'SIU Edwardsville': { abbr: 'SIUE', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2565.png' },
  SMU: { abbr: 'SMU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2567.png' },
  'South Alabama': { abbr: 'USA', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/6.png' },
  'South Carolina': { abbr: 'SC', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2579.png' },
  'South Carolina State': {
    abbr: 'SCST',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2569.png',
  },
  'South Carolina Upstate': {
    abbr: 'UPST',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2908.png',
  },
  'South Dakota': { abbr: 'SDAK', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/233.png' },
  'South Dakota State': {
    abbr: 'SDST',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2571.png',
  },
  'South Florida': { abbr: 'USF', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/58.png' },
  'Southeast Missouri State': {
    abbr: 'SEMO',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2546.png',
  },
  'Southern Illinois': { abbr: 'SIU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/79.png' },
  Southern: { abbr: 'SOU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2582.png' },
  'Southern Indiana': { abbr: 'USI', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/88.png' },
  'Southern Miss': { abbr: 'USM', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2572.png' },
  'Southern Utah': { abbr: 'SUU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/253.png' },
  'St. Bonaventure': { abbr: 'SBU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/179.png' },
  "St. John's": { abbr: 'SJU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2599.png' },
  'St. Thomas-Minnesota': {
    abbr: 'STMN',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2900.png',
  },
  Stanford: { abbr: 'STAN', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/24.png' },
  'Stephen F. Austin': { abbr: 'SFA', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2617.png' },
  Stetson: { abbr: 'STET', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/56.png' },
  Stonehill: { abbr: 'STO', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/284.png' },
  'Stony Brook': { abbr: 'STBK', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2619.png' },
  Syracuse: { abbr: 'SYR', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/183.png' },
  'Tarleton State': { abbr: 'TAR', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2627.png' },
  TCU: { abbr: 'TCU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2628.png' },
  Temple: { abbr: 'TEM', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/218.png' },
  'Tennessee State': { abbr: 'TNST', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2634.png' },
  'Tennessee Tech': { abbr: 'TNTC', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2635.png' },
  Tennessee: { abbr: 'TENN', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2633.png' },
  'Texas A&M': { abbr: 'TA&M', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/245.png' },
  'Texas A&M-Corpus Christi': {
    abbr: 'AMCC',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/357.png',
  },
  Texas: { abbr: 'TEX', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/251.png' },
  'Texas Southern': { abbr: 'TXSO', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2640.png' },
  'Texas State': { abbr: 'TXST', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/326.png' },
  'Texas Tech': { abbr: 'TTU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2641.png' },
  'The Citadel': { abbr: 'CIT', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2643.png' },
  Toledo: { abbr: 'TOL', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2649.png' },
  Towson: { abbr: 'TOW', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/119.png' },
  Troy: { abbr: 'TROY', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2653.png' },
  Tulane: { abbr: 'TULN', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2655.png' },
  Tulsa: { abbr: 'TLSA', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/202.png' },
  UAB: { abbr: 'UAB', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/5.png' },
  UAlbany: { abbr: 'UALB', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/399.png' },
  'UC Davis': { abbr: 'UCD', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/302.png' },
  'UC Irvine': { abbr: 'UCI', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/300.png' },
  'UC Riverside': { abbr: 'UCR', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/27.png' },
  'UC San Diego': { abbr: 'UCSD', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/28.png' },
  'UC Santa Barbara': { abbr: 'UCSB', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2540.png' },
  UCF: { abbr: 'UCF', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2116.png' },
  UCLA: { abbr: 'UCLA', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/26.png' },
  UConn: { abbr: 'CONN', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/41.png' },
  UIC: { abbr: 'UIC', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/82.png' },
  'UL Monroe': { abbr: 'ULM', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2433.png' },
  'UMass Lowell': { abbr: 'UML', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2349.png' },
  UMBC: { abbr: 'UMBC', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2378.png' },
  'UNC Asheville': { abbr: 'UNCA', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2427.png' },
  'UNC Greensboro': { abbr: 'UNCG', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2430.png' },
  'UNC Wilmington': { abbr: 'UNCW', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/350.png' },
  UNLV: { abbr: 'UNLV', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2439.png' },
  USC: { abbr: 'USC', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/30.png' },
  'UT Arlington': { abbr: 'UTA', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/250.png' },
  'UT Martin': { abbr: 'UTM', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2630.png' },
  'UT Rio Grande Valley': {
    abbr: 'RGV',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/292.png',
  },
  'Utah State': { abbr: 'USU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/328.png' },
  'Utah Tech': { abbr: 'UTU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/3101.png' },
  Utah: { abbr: 'UTAH', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/254.png' },
  'Utah Valley': { abbr: 'UVU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/3084.png' },
  UTEP: { abbr: 'UTEP', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2638.png' },
  UTSA: { abbr: 'UTSA', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2636.png' },
  Valparaiso: { abbr: 'VAL', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2674.png' },
  Vanderbilt: { abbr: 'VAN', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/238.png' },
  VCU: { abbr: 'VCU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2670.png' },
  Vermont: { abbr: 'UVM', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/261.png' },
  Villanova: { abbr: 'VILL', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/222.png' },
  Virginia: { abbr: 'UVA', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/258.png' },
  'Virginia Tech': { abbr: 'VT', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/259.png' },
  VMI: { abbr: 'VMI', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2678.png' },
  Wagner: { abbr: 'WAG', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2681.png' },
  'Wake Forest': { abbr: 'WAKE', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/154.png' },
  Washington: { abbr: 'WASH', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/264.png' },
  'Washington State': { abbr: 'WSU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/265.png' },
  'Weber State': { abbr: 'WEB', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2692.png' },
  'West Georgia': { abbr: 'WGA', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2698.png' },
  'West Virginia': { abbr: 'WVU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/277.png' },
  'Western Carolina': { abbr: 'WCU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2717.png' },
  'Western Illinois': { abbr: 'WIU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2710.png' },
  'Western Kentucky': { abbr: 'WKU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/98.png' },
  'Western Michigan': { abbr: 'WMU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2711.png' },
  'Wichita State': { abbr: 'WICH', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2724.png' },
  'William & Mary': { abbr: 'W&M', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2729.png' },
  Winthrop: { abbr: 'WIN', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2737.png' },
  Wisconsin: { abbr: 'WIS', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/275.png' },
  Wofford: { abbr: 'WOF', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2747.png' },
  'Wright State': { abbr: 'WRST', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2750.png' },
  Wyoming: { abbr: 'WYO', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2751.png' },
  Xavier: { abbr: 'XAV', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2752.png' },
  Yale: { abbr: 'YALE', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/43.png' },
  'Youngstown State': { abbr: 'YSU', logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2754.png' },
};

/** Left out: schools with no women's Division I team (neither BDL nor ESPN lists them). */
export const WNCAAB_TEAMS: Record<string, TeamInfo> = Object.fromEntries(
  Object.entries(NCAAB_TEAMS).filter(([school]) => school !== 'The Citadel' && school !== 'VMI'),
);
